/**
 * @fileoverview PlayerSearchcomponent
 *
 * Will implement teh Player Search functionality
 */

 import Data from '../../utils/dom/data';
 import Modal from '../Modal';
 import SelfSubmissionPlayerSuggestionInput from '../SelfSubmission/SelfSubmissionPlayerSuggestionInput';
 import attachValidation from '../../utils/form-validation';
 import EventHandler from '../../utils/dom/event-handler';
 import SelectorEngine from '../../utils/dom/selector-engine';
 import Request from '../../utils/request';
 import Manipulator from '../../utils/dom/manipulator';
 import { getDataFromForm } from '../../utils/misc';
import BaseComponent from '../BaseComponent';

 const NAME = 'PlayerSearch';
 const DATA_KEY = 'lta.PlayerSearch';
 const EVENT_KEY = `.${DATA_KEY}`;
 const EVENT_FAVPLAYER_ADDED = `${DATA_KEY}-FavouritePlayerAdded`;

 class PlayerSearch extends BaseComponent {
     constructor(element = null) {
         super(element);
         this.state = {
             count: 0,
             players: [],
             existingPlayers: [],
             removedPlayers: [],
             addedPlayers: [],
             currentPlayer: null
         }
         this._wrapper = element;
         this._playersWrapper;
         this._suggestion;
         this._suggestionInput;
         this._action;
         this._paymentModal;
         this._paymentCancel;
         this._paymentForm;
         this._fp;
         this._retrivePlayer = undefined;
         this._generalError = undefined;
         this._mainLabel = undefined;
         this._myContactId = document.querySelector('#self-submission-data-attr').getAttribute('data-ss-primary-contact-id');
         this.initiateSearch();
     }

     static get NAME() {
        return NAME;
    }

    // Getters
    static get DATA_KEY() {
        return DATA_KEY;
    }

    dispose() {
        super.dispose()
        // Remove event handlers, reset constructor public settings etc.
    }

     initiateSearch() {
        //  this._wrapper = SelectorEngine.findOne('.lta-player-ss-search-fav');

         if (this._wrapper !== null) {
             this._retrivePlayer = SelectorEngine.findOne('.js-retrive-ss-players', this._wrapper);

             this._playersWrapper = SelectorEngine.findOne('.lta-player-ss-search--players', this._wrapper);
             this._suggestion = SelectorEngine.findOne('.lta-player-ss-search--search', this._wrapper);
             this._suggestionInput = SelectorEngine.findOne('.lta-text-ss-input', this._suggestion);
             this._action = SelectorEngine.findOne('.lta-player-ss-search--add', this._wrapper);
             this._paymentModal = new Modal(this._wrapper.querySelector('#player-ss-search-modal'), {});
             this._paymentForm = SelectorEngine.findOne('#player-payment', this._wrapper);
             this._paymentCancel = SelectorEngine.findOne('.js-payment-cancel', this._wrapper);
             this._generalError = SelectorEngine.findOne('.lta-player-ss-search--error', this._wrapper);
             this._mainLabel = SelectorEngine.findOne('.lta-text-input__label', this._wrapper);
			 this.addFavBtn = SelectorEngine.findOne('.js-lta-play-add-fav-btn');
             this.cancelBtn = SelectorEngine.findOne('.js-my-favourite-player-cancel');

             const suggestionInputEl = SelectorEngine.findOne('.lta-ss-player-autosuggest-input', this._wrapper);
             this.suggestionInput = SelfSubmissionPlayerSuggestionInput.getInstance(suggestionInputEl) || new SelfSubmissionPlayerSuggestionInput(suggestionInputEl);

             if (this._generalError !== null) {
                 const generalErrorClose = SelectorEngine.findOne('.js-dismiss-ss-players-error', this._generalError);
                 generalErrorClose.addEventListener('click', () => {
                     this._generalError.classList.add('u-hidden');
                 });
                }
                this._paymentCancel.addEventListener('click', () => {
                this.suggestionInput.clearSelectedResult(this.state.currentPlayer.playerId);
                this._paymentModal.hide();
             });

             if (this._retrivePlayer !== null) {
                 this.loadExistingPlayers();
             }

             this._fp = attachValidation(this._paymentForm, {
                 paymentMethod: {
                     validators: {
                         notEmpty: {
                             message: "Please select a payment type"
                         }
                     }
                 }
             });
             this._wrapper.addEventListener('playerSelect', (event) => {
                this.addPaymentInfo(event.detail);
                this.state.currentPlayer = event.detail;
                this.state.count = this.state.count + 1;
                const updatedPlayerDetails = Object.assign({}, this.state.currentPlayer, { playerClass: this.state.count });
                this.state.currentPlayer = updatedPlayerDetails;
                this.addPlayer();
             }, false);



             this._fp.on('core.form.valid', () => {
				 const dataObject = getDataFromForm(this._paymentForm);

                 this.state.count = this.state.count + 1;

                 const updatedPlayerDetails = Object.assign({}, this.state.currentPlayer, { paymentType: dataObject.paymentMethod, playerClass: this.state.count });
                 this.state.currentPlayer = updatedPlayerDetails;
                 this.state.addedPlayers.push(updatedPlayerDetails);

                 this.addPlayer();
                 const removeCtas = SelectorEngine.find('.lta-player-ss-search--remove', this._playersWrapper);
                 this._suggestion.classList.add('u-hidden');
                 this._action.classList.remove('u-hidden');
                 this._paymentModal.hide();
                 this._fp.resetForm(true);
                 removeCtas[removeCtas.length - 1].focus();
             });

             const addPlayerButton = this._wrapper.querySelector('.js-add-ss-player');
             addPlayerButton.addEventListener('click', () => {
                 this._suggestion.classList.remove('u-hidden');
                 this._suggestionInput.value = '';
                 this._suggestionInput.focus();
                 this._action.classList.add('u-hidden');
				 this.addFavBtn.classList.remove('u-hidden');
             })
         }

     }

     async loadExistingPlayers() {
         this._suggestion.classList.add('u-hidden');
         this._action.classList.remove('u-hidden');

         const existingPlayers = await Request.get('/api/account/players')
             .catch(() => {
                 this._generalError.classList.remove('u-hidden');
                 const generalErrorClose = SelectorEngine.findOne('.js-dismiss-ss-players-error', this._generalError);
                 generalErrorClose.focus();
             });

         if (existingPlayers.playerDetails.length > 0) {
             existingPlayers.playerDetails.forEach((player) => {
                 this.state.count = this.state.count + 1;
                 const updatedPlayer = Object.assign({}, player, { playerClass: this.state.count });
                 this.state.players.push(updatedPlayer);
                 this.state.existingPlayers.push(updatedPlayer);
                 this.addPlayer(updatedPlayer);
             });
         }
     }

     addPaymentInfo(player) {
         this.state.currentPlayer = player;
     }

     addPlayer(player = this.state.currentPlayer) {
        const playerTemplate = SelectorEngine.findOne('.lta-player--template', this._wrapper);
        const locationCard = SelectorEngine.findOne('.lta-location-card', playerTemplate);
        const playerWrapper = locationCard.cloneNode(true);
        playerWrapper.setAttribute('id', `player-${player.playerClass}`);
        const contentWrapper = SelectorEngine.findOne('.lta-location-card--content', playerWrapper);
        const [wrapperForm] = SelectorEngine.find('form', this._playersWrapper);
        const playerFavouriteButton = SelectorEngine.findOne('.lta-player-ss-save-favourite', playerWrapper);
        const removeFavouriteButton = SelectorEngine.findOne('.lta-player-ss-remove-favourite', playerWrapper);
        this.isFavouritePlayer(player, playerFavouriteButton, removeFavouriteButton);

         const removeCta = SelectorEngine.findOne('.lta-player-ss-search--remove', playerWrapper);
         removeCta.dataset.ltaNumber = player.playerClass;

         const paragraph = document.createElement('p');
         paragraph.classList.add('u-h6', 'u-text-lta-dark-blue');
         const image = document.createElement('img');
         image.style.marginRight = '10px';
         image.src = '/static/images/logos/wtn.png';
         image.width=16;
         image.height=16;
         const playerDetails = document.createTextNode(player.firstname + ' ' + player.lastname + ' ' + '(' + player.gender + ')');
         const playerAdvantageNumber = document.createTextNode(`Advantage number: ` + player.ltanumber);
         const playerCityCountyDetails = document.createTextNode(player.city + (player.city && `, `) + player.county);
         const wtnNumber = document.createTextNode(`WTN number: `);
         const matchScores = document.createTextNode(player.singleswtn ? (`Singles ${player.singleswtn}`) : '' + ' ' + player.doubleswtn ? (`Doubles ${player.doubleswtn}`) : '');
        //  const lastPlayed = document.createTextNode(`Last Played:  ${player.lastplayed}`);
         paragraph.append(playerDetails);
         const playerText = document.createElement('h5');
         playerText.classList.add('u-body3', 'u-text-lta-dark-blue');
         playerText.append(paragraph);
         player.ltanumber && playerText.append(playerAdvantageNumber);
         playerText.append(document.createElement('br'));
         playerText.append(playerCityCountyDetails);
         if(!player.singleswtn || !player.doubleswtn || (player.singleswtn != '40.99' || player.doubleswtn != '40.99')) {
            playerText.append(document.createElement('br'));
            playerText.append(document.createElement('br'));
            playerText.append(image);
            playerText.append(wtnNumber);
         }
         if(player.singleswtn != '40.99' || player.doubleswtn != '40.99') {
            playerText.append(document.createElement('br'));
            playerText.append(matchScores);
         }

        //  if(player.lastplayed !== null)  {
        //     playerText.append(document.createElement('br'));
        //     playerText.append(document.createElement('br'));
        //     playerText.append(lastPlayed)
        //  }
         contentWrapper.append(playerText);
         //  this._wrapper.nextElementSibling.classList.remove('u-hidden');
        //  if(!this._wrapper.classList.contains('js-opponent1-player-search')) {
        //     this._wrapper.closest('.js-lta-section-content').querySelector('.js-next-section').classList.remove('u-hidden');
        //  } else if(this._wrapper.classList.contains('js-opponent1-player-search')) {
        //      // If opponent 2 does not have favourite players
        //      if(document.getElementById('hidden-id-fav-players') != null) {
        //         this._wrapper.closest('.lta-section-content').nextElementSibling.nextElementSibling.classList.remove('u-hidden');
        //     } else {
        //         this._wrapper.closest('.lta-section-content').nextElementSibling.nextElementSibling.nextElementSibling.classList.remove('u-hidden');
        //         this._wrapper.closest('.lta-section-content').nextElementSibling.nextElementSibling.nextElementSibling.querySelector('.js-show-favourites-opponent2-search').classList.add('u-hidden');
        //     }

        //  }
         this._suggestion.classList.add('u-hidden');
		 this.addFavBtn.classList.remove('u-hidden');

         const hiddenInput = (name, value) => {
             const input = document.createElement('input');
             input.setAttribute('type', 'text');
             input.classList.add('u-hidden');
             input.setAttribute('name', name);
             input.setAttribute('value', value);
             return input;
         }

         const playerLtaNumber = hiddenInput(`playerDetails[${this.state.players.length}][playerLtaNumber]`, player.ltanumber);

         contentWrapper.append(playerLtaNumber);
         wrapperForm.innerHTML = '';
         wrapperForm.append(playerWrapper);
         this._mainLabel.classList.remove('u-hidden');

         const playerRemoveButton = SelectorEngine.findOne('.lta-player-ss-search--remove', playerWrapper);
         this.state.players.push(player);

         playerLtaNumber.dispatchEvent(this.createEvent());
         this.state.currentPlayer = null;
         playerRemoveButton.addEventListener('click', (event) => {
             this.removePlayer(event);
         })

        this.addFavBtn.addEventListener('click', (event) => {
            this.saveFavouritePlayer(event, playerFavouriteButton, removeFavouriteButton);
        });

        this.cancelBtn.addEventListener('click', (event) => {
            this.resetSelctedPlayer();
        });

		const actionBtns = SelectorEngine.findOne('.lta-location-card--actions', this._playersWrapper);
		actionBtns?.classList?.add('u-hidden');

     }

     async isFavouritePlayer(currentPlayer, playerFavouriteButton, removeFavouriteButton) {
        const favPlayer =  await Request.get(`/api/selfsubmission/getfavouriteplayerbycontactid?ContactId=${this._myContactId}`).catch(e => {
            if(e.errors.errorcode == '99') {
                console.log(e.errors);
            }
        });

        if(favPlayer && favPlayer.response.favourites) {
            if(JSON.stringify(favPlayer.response.favourites).includes(currentPlayer.id)) {
                playerFavouriteButton.classList.add('u-hidden');
                removeFavouriteButton.classList.remove('u-hidden');
            } else{
                playerFavouriteButton.classList.remove('u-hidden');
                removeFavouriteButton.classList.add('u-hidden');
            }
        } else {
            playerFavouriteButton.classList.remove('u-hidden');
            removeFavouriteButton.classList.add('u-hidden');
        }
     }

     createEvent() {
         const formEvent = new CustomEvent('change', {
             bubbles: true,
             detail: {
                 name: 'playerDetails',
                 values: this.state.players,
                 add: this.state.addedPlayers,
                 remove: this.state.removedPlayers
             }
         });
         return formEvent;
     }

     removePlayer(event) {
         const idToRemove = event?.target?.dataset?.ltaNumber || event;
         const playerToRemove = SelectorEngine.findOne(`#player-${idToRemove}`, this._playersWrapper);
         const [input] = playerToRemove.querySelectorAll('input');
         const [removedPlayer] = this.state.players.filter((player) => player.playerClass === Number(idToRemove));
         const remainingPlayers = this.state.players.filter((player) => player.playerClass !== removedPlayer.playerClass);
         this.state.players = remainingPlayers;
         const [isAddedPlayer] = this.state.addedPlayers.filter((player) => player.playerClass === removedPlayer.playerClass);
         if (isAddedPlayer){
             this.state.addedPlayers = this.state.addedPlayers.filter((player) => player.playerClass !== Number(idToRemove));
         } else {
             this.state.removedPlayers.push(removedPlayer);
         }

         input.dispatchEvent(this.createEvent());
         playerToRemove.remove();

         this.suggestionInput.clearSelectedResult(removedPlayer.ltaNumber);

         this._wrapper.nextElementSibling.classList.remove('u-hidden');
        //  if(!this._wrapper.classList.contains('js-opponent1-player-search')) {
        //     this._wrapper.closest('.js-lta-section-content').querySelector('.js-next-section').classList.add('u-hidden');
        //  }

         if (this.state.players.length === 0) {
             this._suggestion.classList.remove('u-hidden');
             this.suggestionInput.value = '';
           //  this._suggestionInput.focus();
             this._mainLabel.classList.add('u-hidden');
             if (this._retrivePlayer !== null) {
                 this._suggestion.classList.add('u-hidden');
                 this._action.classList.remove('u-hidden');
             } else {
                 this._action.classList.add('u-hidden');
             }
         }
     }

     resetSelctedPlayer(){
        this.suggestionInput.clearSelectedResults();
        this.state.count = 0;
        const playerToRemove = SelectorEngine.findOne(`#player-1`, this._playersWrapper);
        const suggestionInput = SelectorEngine.findOne('input[type="text"]', this._suggestion);
        suggestionInput.value= "";
        this.state.players = [];
        
        if(playerToRemove){
            playerToRemove.remove();
        }
        
        this._wrapper.nextElementSibling.classList.remove('u-hidden');

        if (this.state.players.length === 0) {
            this._suggestion.classList.remove('u-hidden');
            this.suggestionInput.value = '';
          //  this._suggestionInput.focus();
            this._mainLabel.classList.add('u-hidden');
            if (this._retrivePlayer !== null) {
                this._suggestion.classList.add('u-hidden');
                this._action.classList.remove('u-hidden');
            } else {
                this._action.classList.add('u-hidden');
            }
        }
     }

     saveFavouritePlayer(e, playerFavouriteButton, removeFavouriteButton) {
        this.setFavouriteplayer(this.state.players[0].contactid, this._myContactId, playerFavouriteButton, removeFavouriteButton);
     }

     removeFavouritePlayer(e, playerFavouriteButton, removeFavouriteButton) {
        this.unFavouriteplayer(this.state.players[0].contactid, this._myContactId, playerFavouriteButton, removeFavouriteButton);
     }

     async unFavouriteplayer(favoritePlayerContactId, myContactId, playerFavouriteButton, removeFavouriteButton) {
        const payload = Object.assign({}, {
            'ContactId': myContactId,
            'favourites': [favoritePlayerContactId]
        })
        const unFavourites = await Request.post('/api/selfsubmission/Deletefavouriteplayerbycontactid', payload)
        .catch((e) => {
           console.log(e.errors);
        });

        if(unFavourites && unFavourites.errors.errorcode == '00') {
            playerFavouriteButton.classList.remove('u-hidden');
            removeFavouriteButton.classList.add('u-hidden');
            document.querySelector('.js-set-fav-text').classList.remove('u-hidden');
            document.querySelector('.js-set-fav-text').innerText = unFavourites.response.message;
            setTimeout(() => {
                document.querySelector('.js-set-fav-text').classList.add('u-hidden');
            }, 5000);
            return true;
        }
     }

     async setFavouriteplayer(favoritePlayerContactId, myContactId, playerFavouriteButton, removeFavouriteButton) {
        const payload = Object.assign({}, {
            'ContactId': myContactId,
            'favourites': [favoritePlayerContactId]
        })
        const setfavourites = await Request.post('/api/selfsubmission/Setfavouriteplayerbycontactid', payload)
        .catch((e) => {
           console.log(e.errors);
        });

        if(setfavourites && setfavourites.errors.errorcode == '00') {
            playerFavouriteButton.classList.add('u-hidden');
            removeFavouriteButton.classList.remove('u-hidden');
            document.querySelector('.js-set-fav-text').classList.remove('u-hidden');
            document.querySelector('.js-set-fav-text').innerText = setfavourites.response.message;
            setTimeout(() => {
                document.querySelector('.js-set-fav-text').classList.add('u-hidden');
            }, 5000);

            this.resetSelctedPlayer();
            EventHandler.trigger(this.addFavBtn, EVENT_FAVPLAYER_ADDED);
        
            return true;
        } else if(setfavourites && setfavourites.errors.errorcode == '01') {
            document.querySelector('.js-set-fav-text').classList.remove('u-hidden');
            document.querySelector('.js-set-fav-text').innerText = setfavourites.response.message;
            setTimeout(() => {
                document.querySelector('.js-set-fav-text').classList.add('u-hidden');
            }, 5000);
        }
    }
 }

//  const globalPlayerSearch = new PlayerSearch();

 export default PlayerSearch;
